import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MEGACABLE_AUTH_EXCLUDED_PATHS,
  MEGACABLE_AUTH_HEADER
} from '../constants/megacable-auth.constants';
import { MegacableAuthService } from '../services/megacable-auth.service';

@Injectable()
export class MegacableAuthInterceptor implements HttpInterceptor {

  constructor(private readonly _megacableAuth: MegacableAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this._shouldAttachToken(req.url)) {
      return next.handle(req);
    }

    const token = this._megacableAuth.getAuthHeaderValue();
    if (!token) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          [MEGACABLE_AUTH_HEADER]: token
        }
      })
    );
  }

  private _shouldAttachToken(url: string): boolean {
    if (!url.includes('/Megacable/')) {
      return false;
    }
    return !MEGACABLE_AUTH_EXCLUDED_PATHS.some((path) => url.includes(path));
  }
}
